<template>
  <el-table
    id="out-table"
    :data="tableData"
    v-loading="loading"
    @selection-change="selectionChange"
    size="small"
    style="width: 100%"
  >
    <template v-for="item in columns" >
      <el-table-column
        :key="item.key"
        :prop="item.dataIndex"
        :label="item.title"
        :width="item.width"
        :type="item.type"
        v-if="!item.slots"
        show-overflow-tooltip
      > 
      <!-- 鼠标悬停到头部标题显示的提示信息 -->
        <template #header  v-if="item.headerTips">
          <el-tooltip effect="dark" :content="item.headerTips" placement="top">
            <span
              >{{ item.title }}<el-icon><info-filled /></el-icon
            ></span>
          </el-tooltip>
        </template>
        <!-- <template #chilren  v-if="item.type == 'expand'">
           <slot :name="item.slots" :row="scope.row"></slot>
        </template> -->
      </el-table-column>
      <el-table-column
        v-else
        :key="item.key"
        :label="item.title"
        :fixed="item.fixed"
        :width="item.width"
        :type="item.type"
      >
        <template slot-scope="scope">
          
          <slot :name="item.slots" :row="scope.row"></slot>
        </template>
      </el-table-column>
    </template>
  </el-table>
</template>

<script>
export default {
    props:{
      // 展示那些变量
      columns:{
        type:Array,
        default() {
          return [];
        },
      },
      // 渲染表格数据
      tableData:{
        type:Array,
        default() {
          return [];
        },
      },
      // 正在加载
      loading:{
        type:Boolean,
        default:false,
      },
      // 选择项发生变化时会触发该事件
      selectionChange:{
        type:Function,
        default: function () {},
      }
    },
    data(){
        return{}
    },
    mounted(){
        // console.log(this.columns);
        // console.log(this.tableData);
        // console.log(this.loading);
    }
}
</script>

<style scoped>
::v-deep thead tr .el-table__cell {
  background-color: #f2f2f2;
  color: #333333;
}
</style>
